import { render, staticRenderFns } from "./ProblemPassageContent.vue?vue&type=template&id=71a59b51&scoped=true&lang=pug&"
import script from "./ProblemPassageContent.vue?vue&type=script&lang=ts&"
export * from "./ProblemPassageContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemPassageContent.vue?vue&type=style&index=0&id=71a59b51&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a59b51",
  null
  
)

export default component.exports